import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Paper,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import FormatPrice from 'components/shared/FormatPrice';
import { Checkbox } from 'components/FormInputs';

const styles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`,
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  current: {
    backgroundColor: theme.palette.primary[400],
    display: 'inline-block',
    marginTop: -theme.spacing(1) * 1.6,
    borderRadius: theme.spacing(1),
    color: theme.palette.common.white,
    padding: `${theme.spacing(0.25)}px ${theme.spacing(0.5)}px`,
    position: 'absolute',
    right: theme.spacing(3.6),
  },
  selected: {
    boxShadow: `0 0 8px ${theme.palette.primary[500]}`,
  },
  price: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  priceText: {
    fontWeight: 500,
  },
}));

const GALLERY = {
  5: (
    <FormattedMessage
      id="gallery.three.months"
      defaultMessage="Ranking boost 3 months"
    />
  ),
  8: (
    <FormattedMessage
      id="gallery.six.months"
      defaultMessage="Ranking boost 6 months"
    />
  ),
  9: (
    <FormattedMessage
      id="gallery.twelve.months"
      defaultMessage="Ranking boost 12 months"
    />
  ),
};

const TRANSLATION = {
  6: (
    <FormattedMessage
      id="translation.english"
      defaultMessage="Translation english"
    />
  ),
  7: (
    <FormattedMessage
      id="translation.german"
      defaultMessage="Translation german"
    />
  ),
};

const AddonsFormSection = ({
  addons,
  formValues,
  onChange,
  disabled,
}) => {
  const classes = styles();

  // Disable gallery addons
  // const galleries = addons.filter(({ id }) => [5, 8, 9].includes(id));
  const galleries = [];
  const translations = addons.filter(({ id }) => [6, 7].includes(id));

  return (
    <Grid container spacing={2} justifyContent="center">
      {
        !!galleries.length && (
          <Grid item md={6} container>
            <Paper
              className={classes.root}
            >
              {
                galleries.map((gallery, i) => {
                  return (
                    <Grid item xs={12} container key={i}>
                      <Grid item xs={9}>
                        <Checkbox
                          name="gallery"
                          value={formValues.gallery == gallery.id} // eslint-disable-line
                          disabled={(formValues.gallery && formValues.gallery !== gallery.id) || disabled}
                          errors={{}}
                          label={GALLERY[gallery.id]}
                          onChange={() => onChange('gallery')(formValues.gallery == gallery.id ? null : gallery.id)} // eslint-disable-line
                        />
                      </Grid>
                      <Grid item xs={3} className={classes.price}>
                        <Typography align="right" className={classes.priceText}>
                          {gallery.discount ? (
                            <>
                              <FormatPrice price={gallery.price + gallery.discount.price} />
                            </>
                          ) :
                            <FormatPrice price={gallery.price} />}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })
              }
              <Grid item xs={12}>
                <FormattedMessage
                  id="gallery.description"
                  defaultMessage="Ranking boost makes your ad more visible and increases the chances of more guest requests."
                />
              </Grid>
            </Paper>
          </Grid>
        )
      }
      {
        !!translations.length && (
          <Grid item xs={12} md={6} container>
            <Paper
              className={classes.root}
            >
              {
                translations.map((translation, i) => {
                  const key = translation.id === 6 ? 'en' : 'de';
                  return (
                    <Grid item container key={i}>
                      <Grid item xs={9}>
                        <Checkbox
                          name={key}
                          value={formValues[key]}
                          errors={{}}
                          label={TRANSLATION[translation.id]}
                          onChange={(e) => onChange(key)(e.target.checked)}
                          disabled={disabled}
                        />
                      </Grid>
                      <Grid item xs={3} className={classes.price}>
                        <Typography align="right" className={classes.priceText}>
                          {translation.discount ? (
                            <>
                              <FormatPrice price={translation.price + translation.discount.price} />
                            </>
                          ) :
                            <FormatPrice price={translation.price} />}
                        </Typography>
                      </Grid>
                    </Grid>
                  );
                })
              }
              <Grid item xs={12}>
                <FormattedMessage
                  id="translation.description"
                  defaultMessage="If you have done a translation before, you do not need to translate the ad again, as long as you have not added any changes that you want translated. Translation is done on the text that the ad currently has. The translation is completed in 1-2 weeks after the payment has reached us."
                />
              </Grid>
            </Paper>
          </Grid>
        )
      }
    </Grid>
  );
};

AddonsFormSection.propTypes = {
  addons: PropTypes.arrayOf(PropTypes.shape({})),
  formValues: PropTypes.shape({
    gallery: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default AddonsFormSection;
